import { render, staticRenderFns } from "./OrderModifyCollector.vue?vue&type=template&id=f3a69a40&scoped=true&"
import script from "./OrderModifyCollector.vue?vue&type=script&lang=js&"
export * from "./OrderModifyCollector.vue?vue&type=script&lang=js&"
import style0 from "./OrderModifyCollector.vue?vue&type=style&index=0&id=f3a69a40&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f3a69a40",
  null
  
)

export default component.exports